<script>
    import { mapActions } from "vuex";
    import Equals from "@/api/query/filters/equals";
    import Sort from "@/api/query/sorts/sort";
    import Paging from "@/api/query/paging/paging";
    import QueryBuilder from "@/api/query/query-builder";
    import ProductStoreItem from "@/components/product/ProductStoreItem";

    export default {
        name: "ProductStoreList",
        components: {
            ProductStoreItem,
        },
        props: {
            city: String,
            offerId: Number,
        },
        data() {
            return {
                storeList: [],
            };
        },
        computed: {
            filteredStoreList() {
                return this.storeList
                    .filter((store) => store.city === this.city && !store.default)
                    .sort((a, b) => a.sort - b.sort);
            },
        },
        watch: {
            filteredStoreList(list) {
                this.$emit("on-update", list);
            },
            city: {
                handler() {
                    this.requestForStoresAmount(this.offerId);
                },
                immediate: true,
            },
            offerId: {
                handler(updatedOffer) {
                    this.requestForStoresAmount(updatedOffer);
                },
            },
        },
        methods: {
            ...mapActions("Product", ["getProductStoresAmount"]),
            requestForStoresAmount(offerId) {
                const filters = [new Equals("productId", offerId)];
                const sorts = [new Sort("amount", "desc")];
                const paging = new Paging(1, 30);

                const query = new QueryBuilder(filters, sorts, paging).build();

                this.getProductStoresAmount(query).then(({ items }) => {
                    this.storeList = items;
                });
            },
        },
    };
</script>

<template>
    <div v-show="filteredStoreList.length > 0" class="product-store-list">
        <div class="product-store-list__title">Фирменный магазин в вашем городе</div>

        <product-store-item
            v-for="store in filteredStoreList"
            :key="store.id"
            :store="store"
        ></product-store-item>
    </div>
</template>

<style lang="scss">
    .product-store-list__title {
        margin-bottom: 8px;
        font-size: 16px;
        line-height: 24px;
        color: var(--primary-text);
    }
</style>
